RivalIQ.apps.Favorites.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const TEMPLATE_GROUPS = {};
    TEMPLATE_GROUPS['cross-channel'] = {
        name: 'Cross-Channel Competitive Data',
        className: _.constant('callout-fa')
    };

    function getChannel(item) {
        const props = _.get(item, ['props'], {});

        let lookup = props.source;
        if (!_.isFinite(lookup)) {
            lookup = props.channel;
        }

        return RivalIQ.data.channels.get(lookup);
    }

    TEMPLATE_GROUPS['channel-specific'] = {
        name: 'Channel-Specific Competitive Data',
        className: function (item) {
            let flavor = 'fa';

            const channel = getChannel(item);
            if (channel.id !== RivalIQ.enums.sources.CROSS_CHANNEL) {
                flavor = channel.get('channel');
            }

            return ['callout', flavor].join('-');
        },
        icon: function (item) {
            const channel = getChannel(item);
            return channel.get('fontIcon');
        }
    };

    TEMPLATE_GROUPS.insights = {
        name: 'Your Private Data',
        className: TEMPLATE_GROUPS['channel-specific'].className,
        icon: TEMPLATE_GROUPS['channel-specific'].icon
    };

    const TEMPLATE_SUBGROUPS = {
        focus_company: {
            name: 'Focus Company'
        },
        landscape: {
            name: 'Landscape'
        }
    };

    function accessibleTemplates(templates) {
        return _.filter(templates, function (template) {
            return (!template.requiredBeta || RivalIQ.state.account.inBeta(template.requiredBeta)) &&
                (!template.requiredPlanFeature || RivalIQ.state.plan.get(template.requiredPlanFeature));
        });
    }

    const Templates = Marionette.Dashboard.views.ItemView.mixin({
        className: 'custom-dashboard-templates',
        template: '#favoritesCreateFromTemplate',
        events: {
            'click [data-template-id]': 'onTemplateClick'
        },
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },
        constructor: function (attributes) {
            const me = this;
            me.model = attributes.dashboardModel.configuration;
            Marionette.Dashboard.views.ItemView.apply(me, arguments);
        },
        loadData: function () {
            const me = this;
            return $.getJSON('/api/configurations/dashboards')
                .then(function (templates) {
                    me.templates = accessibleTemplates(templates);
                });
        },
        templateHelpers: function () {
            const me = this;

            const templateGroups = _.reduce(me.templates, function (memo, template) {
                const allPrivateChannelsSupported =
                    RivalIQ.state.account.channelSupported(RivalIQ.enums.sourceMask.FACEBOOK_INSIGHTS) &&
                    RivalIQ.state.account.channelSupported(RivalIQ.enums.sourceMask.INSTAGRAM_INSIGHTS) &&
                    RivalIQ.state.account.channelSupported(RivalIQ.enums.sourceMask.TWITTER_INSIGHTS) &&
                    RivalIQ.state.account.channelSupported(RivalIQ.enums.sourceMask.LINKEDIN);
                if (!allPrivateChannelsSupported && template.group === 'insights') {
                    // do nothing
                } else {
                    let group = memo[template.group];
                    const groupSettings = TEMPLATE_GROUPS[template.group];
                    if (!group) {
                        group = memo[template.group] = {
                            subgroups: {},
                            name: (groupSettings.name || _.upperFirst(template.group))
                        };
                    }
                    const defaults = _.reduce(['icon', 'className'], function (memo, key) {
                        const fn = groupSettings[key];
                        if (fn) {
                            memo[key] = fn(template);
                        }
                        return memo;
                    }, {});

                    if (template.subgroup) {
                        if (!group.subgroups[template.subgroup]) {
                            group.subgroups[template.subgroup] = {
                                items: [],
                                name: TEMPLATE_SUBGROUPS[template.subgroup].name
                            };
                        }
                        group.subgroups[template.subgroup].items.push(_.extend(defaults, template));
                    } else {
                        if (!group.items) {
                            group.items = [];
                        }
                        group.items.push(_.extend(defaults, template));
                    }
                }
                return memo;
            }, {});

            // If there's a group with empty subgroups, remove them
            _.each(templateGroups, group => {
                if (!_.isEmpty(group.subgroups)) {
                    _.each(group.subgroups, (subgroup, subgroupName) => {
                        if (_.isEmpty(subgroup.items)) {
                            delete group.subgroups[subgroupName];
                        }
                    });

                    if (_.size(group.subgroups) === 1) {
                        group.items = group.subgroups[_.keys(group.subgroups)[0]].items;
                        delete group.subgroups;
                    }
                }
            });

            return {
                copyMode: App.enums.copyMode,
                templateGroups: templateGroups
            };
        },
        onRenderLoaded: function () {
            const me = this;
            me.$('[data-toggle=popover]').popover({
                html: true
            });
        },
        onDestroy: function () {
            const me = this;
            me.$('[data-toggle=popover]').popover('destroy');
        },
        onTemplateClick: function (e) {
            const me = this;

            const $el = $(e.currentTarget);
            const template = _.find(me.templates, {
                id: $el.data('template-id')
            });

            if (!template) {
                return;
            }

            const attrs = _.pick(template, ['name', 'definitions', 'props']);
            const deferred = me.model.save(attrs, {
                copy: App.enums.copyMode.TEMPLATE
            });

            if (!deferred) {
                return;
            }

            deferred
                .done(function () {
                    RivalIQ.execute('history:navigate', `/dashboards/${me.model.id}`, {
                        trigger: true
                    });
                })
                .fail(function () {
                    RivalIQ.execute('alert:danger', 'An error occurred, please try again');
                });
        }
    });

    curations.Templates = curations.Create.extend({
        title: 'Select Template',
        widgetsView: Templates
    });

});
